import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import ICONS from "../../../../../assets/Icons";
import BankDetails from "../../../../../components/_utils/AccountCreationComponents/BankDetails";
import ConfidentialCard from "../../../../../components/_utils/TransactionCommonComponents/ConfidentialCard";
import ConfirmBtnAccCreation from "../../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import ActiveInactiveAssociatePopup from "../../../../../components/_utils/ActiveInactiveAssociatePopup";
import TEXT from "../../../../../utils/globalText";

const FieldForceAccountEditBank = ({
  setBankLookupNext,
  bankLookupNext,
  setBenEnableNextButton,
  payload,
  setPayload,
  activeStep,
  setAssociatedNext,
  setCreateNewEdit,
  benebankLookData,
  isIFSCValid,
  isBankLinkedAccount,
  accActiveInactiveState,
  setAccActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  id,
  manualVirtualAccount,
  setManualVirtualAccount,
  isOriginalManualVirtual,
  resetVerifyRequestRef,
  isBankLookupComplete = false,
  getSpecificFieldForceAccountLoading,
  associatedNext,
  setShowMarkVirtualSection,
  isMarkVirtualVisible,
  virtualAccount,
  setVirtualAccount,
}) => {
  const {
    verifyBankAccountError,
    verifyBankAccountData,
    bankLookupData,
    bankLookupLoading,
    ifscDetailsLoading,
    ifscDetailsData,
    ifscDetailsError,
    verifyBankAccountLoading,
    bankLookupError,
  } = useSelector((state) => state.sharedResources);

  const associatedAccounts =
    bankLookupData?.field_force_accounts ||
    bankLookupData?.beneficiary_accounts ||
    benebankLookData?.field_force_accounts ||
    benebankLookData?.beneficiary_accounts ||
    [];
  const hasJointAssociatedAccounts = associatedAccounts.some(
    (val) =>
      val?.bank_acc_no === payload?.bank_account &&
      val?.ifsc_code === payload?.ifsc_code,
  );
  const isBankDetailsChanged =
    payload?.bank_account !== payload?.old_bank_account ||
    payload?.ifsc_code !== payload?.old_ifsc_code;
  const isBankUnchanged = !isBankDetailsChanged;
  const isExistingManualVirtualUnchanged =
    isOriginalManualVirtual && isBankUnchanged;
  const isLookupPendingForChangedBank =
    isBankDetailsChanged &&
    !manualVirtualAccount &&
    verifyBankAccountData?.status === true &&
    !verifyBankAccountLoading &&
    isIFSCValid &&
    !isBankLookupComplete;

  const ifscData = ifscDetailsData?.ifsc_details?.[0];

  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);

  const isAutoDetectedVirtual =
    virtualAccount &&
    isIFSCValid &&
    payload?.virtual_account_type === "automated";

  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  // Persist across step remount: parent keeps manualVirtualAccount, local flag must follow it.

  const prevBankDetailsRef = useRef({ account: "", ifsc: "" });

  const isExistingManualVirtualLocked = verifyBankAccountData?.status
    ? true
    : isExistingManualVirtualUnchanged && manualVirtualAccount;

  useEffect(() => {
    if (manualVirtualAccount) {
      setShowMarkVirtualSection(true);
    }
  }, [manualVirtualAccount]);

  useEffect(() => {
    if (verifyBankAccountError === true && !isAutoDetectedVirtual) {
      setShowMarkVirtualSection(true);
    }
  }, [verifyBankAccountError, isAutoDetectedVirtual]);

  useEffect(() => {
    if (
      verifyBankAccountData?.status === true &&
      !manualVirtualAccount &&
      !isAutoDetectedVirtual &&
      !isExistingManualVirtualUnchanged
    ) {
      setShowMarkVirtualSection(false);
    }
  }, [
    verifyBankAccountData?.status,
    manualVirtualAccount,
    isAutoDetectedVirtual,
    isExistingManualVirtualUnchanged,
  ]);

  useEffect(() => {
    const account = payload?.bank_account || "";
    const ifsc = payload?.ifsc_code || "";
    const { account: prevAccount, ifsc: prevIfsc } = prevBankDetailsRef.current;

    if (prevAccount && (prevAccount !== account || prevIfsc !== ifsc)) {
      // Keep section visible if user already marked virtual for current flow.
      if (!manualVirtualAccount) {
        setShowMarkVirtualSection(false);
      }
    }

    prevBankDetailsRef.current = { account, ifsc };
  }, [payload?.bank_account, payload?.ifsc_code, manualVirtualAccount]);

  useEffect(() => {
    if (manualVirtualAccount && isIFSCValid) {
      setBankVerificationStatus(true);
    } else if (
      !manualVirtualAccount &&
      !verifyBankAccountLoading &&
      verifyBankAccountData?.status !== true
    ) {
      setBankVerificationStatus(false);
    }
  }, [
    manualVirtualAccount,
    isIFSCValid,
    verifyBankAccountLoading,
    verifyBankAccountData?.status,
  ]);

  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      if (manualVirtualAccount) {
        setCreateNewEdit(false);
        return;
      }

      if (verifyBankAccountError) {
        setBenEnableNextButton(true);
        setCreateNewEdit(true);
        return;
      }

      if (virtualAccount && isIFSCValid) {
        setCreateNewEdit(true);
      }
      if (isBankLinkedAccount) {
        setBenEnableNextButton(true);
        return;
      }
      if (
        payload.bank_account !== payload.old_bank_account &&
        verifyBankAccountData?.status === true &&
        isIFSCValid &&
        !verifyBankAccountLoading
      ) {
        const isAutoVirtual =
          verifyBankAccountData?.verification_details?.[
            GlobalConfiguration.lengthCheckZero
          ]?.is_virtual === "Y";
        if (isLookupPendingForChangedBank) {
          setBenEnableNextButton(true);
        } else if (isAutoVirtual) {
          setBenEnableNextButton(false);
        } else if (hasJointAssociatedAccounts && isBankDetailsChanged) {
          setBenEnableNextButton(false);
        } else {
          setBenEnableNextButton(false);
        }
      }
      if (
        verifyBankAccountData?.verification_details?.[
          GlobalConfiguration.lengthCheckZero
        ]?.account_exists === "N" &&
        !bankLookupData
      ) {
        setBenEnableNextButton(false);
        setCreateNewEdit(true);
      }
      if (payload.bank_account === payload.old_bank_account) {
        if (!(virtualAccount && isIFSCValid)) {
          setCreateNewEdit(false);
        }
      }
      if (payload.bank_account !== payload.old_bank_account && bankLookupData) {
        setCreateNewEdit(true);
        const isAutoVirtual =
          verifyBankAccountData?.verification_details?.[
            GlobalConfiguration.lengthCheckZero
          ]?.is_virtual === "Y";
        if (isLookupPendingForChangedBank) {
          setBenEnableNextButton(true);
        } else if (
          hasJointAssociatedAccounts &&
          isBankDetailsChanged &&
          !isAutoVirtual
        ) {
          setBenEnableNextButton(false);
        }
      }
      if (!payload.bank_account || !payload.ifsc_code) {
        setBenEnableNextButton(true);
      }
      if (payload?.ifsc_code?.length < GlobalConfiguration.ifscLength) {
        setBenEnableNextButton(true);
      }
    }
  }, [
    bankLookupData,
    verifyBankAccountError,
    verifyBankAccountData,
    payload,
    isBankLinkedAccount,
    isIFSCValid,
    verifyBankAccountLoading,
    virtualAccount,
    manualVirtualAccount,
    hasJointAssociatedAccounts,
    isBankDetailsChanged,
    isBankLookupComplete,
    activeStep,
  ]);

  const [showDetails, setShowDetails] = useState(null);

  useEffect(() => {
    if (
      !getSpecificFieldForceAccountLoading &&
      !ifscDetailsLoading &&
      !bankLookupLoading &&
      !verifyBankAccountLoading &&
      !bankLookupData?.beneficiary_accounts?.length &&
      !verifyBankAccountError &&
      isIFSCValid &&
      bankLookupError === true &&
      verifyBankAccountData
    ) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [
    bankLookupLoading,
    verifyBankAccountLoading,
    bankLookupData,
    verifyBankAccountError,
    isIFSCValid,
    getSpecificFieldForceAccountLoading,
    bankLookupError,
    verifyBankAccountData,
    ifscDetailsLoading,
  ]);

  return (
    <div className="max-w-tab-width-normal w-full mx-auto">
      <CommonLayout>
        <div className="w-width-full">
          {isBankLinkedAccount ? (
            <div className=" flex justify-between items-center gap-gap-sm bg-emphasis p-padding-md mb-margin-md rounded-border-radius-md">
              <img
                className="w-icon-md h-icon-md"
                src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                alt="info"
              />
              <p className=" text-text-primary text-font-sm font-normal ">
                The bank account is already linked to the PAN provided. To
                proceed, update either the bank details or the PAN associated
                with the profile.
              </p>
            </div>
          ) : null}

          {virtualAccount &&
          isIFSCValid &&
          payload?.virtual_account_type === "automated" ? (
            <>
              <div className="flex flex-row items-center gap-x-gap-sm bg-emphasis p-padding-md mb-margin-md rounded-border-radius-md">
                <img
                  src={ICONS.VIRTUAL_ACCOUNT}
                  alt="Virtual Account"
                  className="w-icon-md h-icon-md"
                />
                <div className="flex flex-col gap-y-gap-sm">
                  <p className="text-font-sm text-text-primary font-semibold">
                    Virtual Account Detected
                  </p>

                  <ul className="list-disc text-font-xs text-text-secondary pl-padding-button-l ">
                    <li className="mb-margin-sm">
                      Account could not be verified as it is virtual account.
                    </li>
                    <li>Please self verify and proceed with caution.</li>
                  </ul>
                </div>
              </div>
            </>
          ) : null}
          <div className="h-fit w-full lg:max-w-[var(--create-box-width)]">
            <BankDetails
              payload={payload}
              setPayload={setPayload}
              BenEnableNextButton={setBenEnableNextButton}
              activeStep={activeStep}
              setVirtualAccount={setVirtualAccount}
              bankLookupNext={bankLookupNext}
              setBankLookupNext={setBankLookupNext}
              bankVerificationStatus={bankVerificationStatus}
              setBankVerificationStatus={setBankVerificationStatus}
              virtualAccount={virtualAccount}
              isIFSCValid={isIFSCValid}
              setShowDetails={setShowDetails}
              manualVirtualAccount={manualVirtualAccount}
              setManualVirtualAccount={setManualVirtualAccount}
              ifscData={ifscData}
              ownerAccIfscError={ifscDetailsError}
              ownerAccIfscLoading={ifscDetailsLoading}
              setAssociatedNext={setAssociatedNext}
            />
          </div>
        </div>

        <div
          className={`w-width-full flex flex-col    lg:max-w-[var(--create-box-width)]`}
        >
          {isMarkVirtualVisible && (
            <div className="mb-margin-md">
              <ConfidentialCard
                isPreview={false}
                isEnabled={!isExistingManualVirtualLocked}
                icon={ICONS.VIRTUAL_ACCOUNT}
                title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                toggleState={manualVirtualAccount}
                onToggle={() => {
                  const nextState = !manualVirtualAccount;
                  setManualVirtualAccount(nextState);
                  setCreateNewEdit(false);
                  setShowMarkVirtualSection(true);
                  setPayload({
                    ...payload,
                    virtual: nextState ? true : false,
                    virtual_account_type: nextState ? "manual" : "",
                    skip_account_verification: nextState ? "Y" : "N",
                  });
                  if (nextState) {
                    setBankVerificationStatus(true);
                  } else {
                    setBankVerificationStatus(false);
                    resetVerifyRequestRef?.();
                  }
                  if (!nextState && verifyBankAccountError) {
                    setBenEnableNextButton(true);
                  }
                }}
              />
            </div>
          )}
          {payload.bank_account !== payload.old_bank_account &&
            bankLookupLoading === false &&
            ifscDetailsLoading === false &&
            verifyBankAccountLoading === false &&
            !(isBankLinkedAccount && isIFSCValid) && (
              <div style={{ overflow: "hidden" }}>
                <div
                  className={
                    !(isBankLinkedAccount && isIFSCValid)
                      ? "animate-slideInFromRight"
                      : ""
                  }
                >
                  {" "}
                  <ConfirmBtnAccCreation
                    type="bank"
                    status={bankLookupData?.status}
                    isIFSCValid={isIFSCValid}
                    isBankError={verifyBankAccountError}
                    lookupNext={associatedNext}
                    isButtonDisabled={isBankLinkedAccount && isIFSCValid}
                    nextButtonEnabled={!associatedNext}
                    handleClick={() => {
                      setAssociatedNext(true);
                    }}
                  />
                </div>{" "}
              </div>
            )}
          <div
            style={{
              display:
                (bankLookupData?.status &&
                  bankLookupData?.beneficiary_accounts?.length >
                    GlobalConfiguration?.lengthCheckZero) ||
                virtualAccount
                  ? "block"
                  : (isIFSCValid && verifyBankAccountError) ||
                      isMarkVirtualVisible
                    ? "none"
                    : "block",
            }}
          >
            {" "}
            <ActiveInactiveAssociatePopup
              flow={
                verifyBankAccountError === true
                  ? "hideAssociate"
                  : isBankLinkedAccount && isIFSCValid
                    ? "Existing"
                    : showDetails
                      ? "notFoundBank"
                      : !showDetails &&
                          bankLookupData?.beneficiary_accounts?.length
                        ? "Bank"
                        : "defaultBank"
              }
              dropDownNo={GlobalConfiguration?.lengthCheckTwo}
              ifsc={payload?.ifsc_code}
              bank={payload?.bank_account}
              pan={payload?.pan_no}
              accActiveInactiveState={accActiveInactiveState}
              setAccActiveInactiveState={setAccActiveInactiveState}
              currentAssociate={currentAssociate}
              setCurrentAssociate={setCurrentAssociate}
              openAssociatePopup={openAssociatePopup}
              setOpenAssociatePopup={setOpenAssociatePopup}
              activeAssociateId={id}
              ifscLength={payload?.ifsc_code?.length}
            />
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};
export default FieldForceAccountEditBank;
